import Instance from "../../../../Axios";

// New Actions for the app

const GetCredFuncionarioById = (id) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/funcionarios/${id}`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_FUNCIONARIO_BY_ID", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredFuncionarioById;